class FooterAccordion {
  constructor() {
    this.isInitialized = false;
    this.init();
  }

  init() {
    // 初期化状態を確認
    if (window.innerWidth < 768 && !this.isInitialized) {
      this.setupAccordions();
      this.isInitialized = true;
    }
    this.setupResizeHandler();
  }

  setupAccordions() {
    const accordionTriggers = document.querySelectorAll(
      ".js-footer-accordion-trigger"
    );

    accordionTriggers.forEach((trigger) => {
      // イベントリスナーを一度だけ追加
      if (!trigger.hasEventListener) {
        trigger.addEventListener("click", (e) => this.handleAccordionClick(e));
        trigger.hasEventListener = true;
      }
    });
  }

  handleAccordionClick(e) {
    if (window.innerWidth >= 768) return;

    e.preventDefault();
    e.stopPropagation();

    const trigger = e.currentTarget;
    const blockId = trigger.closest("[data-block-id]")?.dataset.blockId;
    if (!blockId) return;

    let content;
    const parentLi = trigger.closest("li");

    if (trigger.closest(".c-footer-menu-title-wrapper")) {
      const menuList = trigger.closest(".c-footer-menu-list");
      content =
        menuList.querySelector(".js-footer-accordion-content") ||
        menuList.querySelector(".c-footer-menu-columns");
    } else if (parentLi) {
      content = parentLi.querySelector(".c-footer-menu-parent");
    }

    if (!content) return;

    // 同じブロック内の他のアコーディオンを閉じる
    const parentContainer =
      trigger.closest("li") || trigger.closest(".c-footer-menu-list");
    if (parentContainer) {
      const siblings = parentContainer.querySelectorAll(
        ".js-footer-accordion-content"
      );
      const siblingTriggers = parentContainer.querySelectorAll(
        ".js-footer-accordion-trigger"
      );

      siblings.forEach((sibling) => {
        if (sibling !== content) {
          sibling.classList.remove("is-active");
        }
      });

      siblingTriggers.forEach((siblingTrigger) => {
        if (siblingTrigger !== trigger) {
          siblingTrigger.classList.remove("is-active");
        }
      });
    }

    content.classList.toggle("is-active");
    trigger.classList.toggle("is-active");

    const link = trigger.querySelector("a");
    if (link && !link.hasEventListener) {
      link.addEventListener("click", (e) => {
        if (window.innerWidth < 768) {
          e.preventDefault();
        }
      });
      link.hasEventListener = true;
    }
  }

  setupResizeHandler() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 768) {
          // PC表示時はアコーディオンの状態をリセット
          document
            .querySelectorAll(
              ".js-footer-accordion-content, .js-footer-accordion-trigger"
            )
            .forEach((el) => el.classList.remove("is-active"));
          this.isInitialized = false;
        } else if (!this.isInitialized) {
          // スマホサイズに変更された時に初期化
          this.init();
        }
      }, 250);
    });
  }
}

// DOMContentLoadedで初期化
document.addEventListener("DOMContentLoaded", () => {
  new FooterAccordion();
});
